
const isDevelopment = process.env.NODE_ENV === 'development';
// const devOrigin = isDevelopment && require('./proxy');
// // 控制本地开发环境是否使用mock数据，
// const isMock = isDevelopment && !location.origin.match(/\.lagou.com/); //xxx.lagou.com域名不使用mock数据
// const getDevHost = (origin) => {
//     const proxy = devOrigin[origin] && devOrigin[origin].proxy ? devOrigin[origin].proxy : '/api';
//     const devPath = devOrigin[origin] && devOrigin[origin].dev ? devOrigin[origin].dev : '';
//     const devHost = isMock ? devPath : location.origin + proxy;
//     return devHost;
// };
const HOST = {
    // gwctx: isDevelopment ? getDevHost('gwctx') : 'https://gw.lagou.com',
    // gzctx: isDevelopment ? getDevHost('gzctx') : 'https://gate.lagou.com/v1/zhaopin',
    gnctx: isDevelopment ? '/gnctx' : 'https://gate.lagou.com/v1/neirong',
    gtctx: isDevelopment ? '/gtctx' : 'https://gate.lagou.com/v1/neirong/edu',
    gwctx: isDevelopment ? '/gwctx' : 'https://gate.lagou.com/v1/',
    // gmctx: isDevelopment ? getDevHost('gmctx') : 'https://gate.lagou.com/v1/minorcourse/edu', // 小课接口
    // gtptx: isDevelopment ? getDevHost('gtptx') : 'https://gate.lagou.com/v1',
    // gentx: isDevelopment ? getDevHost() : 'https://gate.lagou.com/v1/entry',
    // appsa: isDevelopment ? getDevHost('appsa') : 'https://appsa.lagou.com'
};
export default HOST;